import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Grid,
  IconButton,
  CircularProgress,
  TextField,
  Typography,
  CardMedia,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { useMediaQuery, useTheme } from '@mui/material';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";


const EditProductPage = () => {
  const { productId } = useParams();
  
  const [product, setProduct] = useState({
    title: "",
    categoryName: "",
    description: "",
    price: 0,
    location: "",
    promotionStatus: "",
    imagePaths: [],
    videoPath: "",
    postByUserid: 0,
  });
// eslint-disable-next-line 
  const [category, setCategory] = useState('');
  const [originalProduct, setOriginalProduct] = useState(null);

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [price, setPrice] = useState('');
  const [location, setLocation] = useState('');
  // eslint-disable-next-line 
  const [duration, setDuration] = useState('');
  const [newImage, setNewImage] = useState(null);
  // eslint-disable-next-line 
  const [newThumbnails, setNewThumbnails] = useState([]);
  const [newVideo, setNewVideo] = useState(null);
  const theme = useTheme();
  const navigate = useNavigate();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md')); 
  const [loading, setLoading] = useState(false); 
  const [successModalOpen, setSuccessModalOpen] = useState(false); 
  const [errorModalOpen, setErrorModalOpen] = useState(false); 
  const [availability, setAvailability] = useState('');
  const [promotionDuration, setPromotionDuration] = useState('');
  const [categoryId, setCategoryId] = useState(null); // Add a state for categoryId



  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const token = localStorage.getItem("token"); 
        if (!token) {
          console.error("No token found. Please log in.");
          return;
        }
  
        const response = await fetch(
          `https://daradservice.azurewebsites.net/api/P2PProducts/get-product?productId=${productId}`,
          {
            headers: {
              "Accept": "application/json",
              "Authorization": `Bearer ${token}`,
            },
          }
        );
  
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
  
        const data = await response.json();
  
        if (data.status) {
          console.log("Fetched Product Data:", data.data);
          
  
          
          setOriginalProduct(data.data); 
          setProduct(data.data);

          setCategory(data.data.categoryName);
          setCategoryId(data.data.categoryId);
          setTitle(data.data.title);
          setDescription(data.data.description);
          setPrice(data.data.price.toLocaleString());
          setLocation(data.data.location);
          setAvailability(data.data.availabiltyDuration || '');
          setPromotionDuration(data.data.promotionDuration || '');
        } else {
          console.error("Product not found");
        }
      } catch (error) {
        console.error("Error fetching product:", error);
      }
    };
  
    fetchProduct();
  }, [productId]);
  
  
  const handleReset = () => {
    if (!originalProduct) return;
  
    setCategory(originalProduct.categoryName);
    setCategoryId(originalProduct.categoryId);
    setTitle(originalProduct.title);
    setDescription(originalProduct.description);
    setPrice(originalProduct.price.toLocaleString());
    setLocation(originalProduct.location);
    setAvailability(originalProduct.availabiltyDuration || '');
    setPromotionDuration(originalProduct.promotionDuration || '');
    setNewImage(null);
    setNewThumbnails([]);
    setNewVideo(null);
  };
  


 

 


  // Save product updates
  const handleSaveUpdates = async () => {
    try {
      const token = localStorage.getItem("token");
  
      if (!token) {
        console.error("No token found in local storage");
        return;
      }
  
      setLoading(true);
  
      const updatedProduct = {
        categoryId,
        title,
        description,
        location,
        price: Number(price),  
        availabilityDuration: availability,
        promotionDuration,
        imageUrl: newImage || product.imagePaths?.[0] || "",
        videoUrl: newVideo || product.videoPath || "",
      };
      
      
  
      console.log("Price being sent:", price);
      console.log("Updated Product:", updatedProduct);

  
      const response = await fetch(
        `https://daradservice.azurewebsites.net/api/P2PProducts/update-product?productId=${productId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(updatedProduct),
        }
      );
      
  
      setLoading(false);
  
      if (!response.ok) {
        const errorData = await response.json();
        console.error("Error details:", errorData);
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
      const data = await response.json();
  
      if (data.status) {
        setSuccessModalOpen(true);
      } else {
        setErrorModalOpen(true);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error updating product:", error);
      setErrorModalOpen(true);
    }
  };
  


  return (

    <Box sx={{ mt: 3 }}>
          <Box sx={{ width: "100%", p: isDesktop ? 4 : 2, position: "relative" }}>
    
          <IconButton 
      onClick={() => navigate("/product/ptwop")} 
      sx={{ 
        position: "absolute",
        top: 20,
        left: 20,
        color: "white", 
        background: "#5604F6 !important",  
        fontSize: "48px",
        borderRadius: "50px",
        zIndex: 1000,
        "&:hover": { background: "#4503D6 !important" } 
      }}
    >
      <ArrowBackIcon />
    </IconButton>
    </Box>
    <Box
      sx={{
        maxWidth: "800px",
        margin: "auto",
        padding: "30px",
        borderRadius: "12px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        backgroundColor: "white",
      }}
    >

      
      {/* Title */}
      <Typography
        variant="h5"
        align="center"
        fontWeight="800"
        sx={{ color: "#2400FF", mb: 1, fontSize: isDesktop ? "48px" : "36px", }}
        

      >
        Edit Product Details
      </Typography>
      <Typography align="center" sx={{ mb: 3, color: "#777" }}>
        Check all the details before submitting. You might like to make changes.
      </Typography>

      {/* Main Product Image */}
     
   
 <Box sx={{ display: "flex", flexDirection: isDesktop ? "row" : "column", alignItems: "center" }}>
  {/* Image Thumbnails */}
  <Grid container spacing={1} sx={{ justifyContent: "center", flexDirection: "column" }}>
  {/* Video Section */}
  {product.videoPath && (
    <Box sx={{ width: "100%", maxWidth: 600, display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
      <video
        src={product.videoPath}
        controls
        autoPlay
        loop
        muted
        style={{ width: "100%", height: "auto", objectFit: "cover", borderRadius: "8px" }}
      />
    </Box>
  )}

  {/* Thumbnails Section */}
  {product.imagePaths.length > 0 && (
    <Box sx={{ display: "flex", justifyContent: "center", gap: 1, flexWrap: "wrap", width: "80%", maxWidth: 500 }}>
      {product.imagePaths.map((thumb, index) => (
        <CardMedia
          key={index}
          component="img"
          image={thumb}
          alt={`Thumbnail ${index + 1}`}
          sx={{
            width: 60,
            height: 60,
            objectFit: "cover",
            borderRadius: "4px",
            cursor: "pointer",
            border: "2px solid transparent",
            "&:hover": { border: "2px solid #007bff" },
          }}
        />
      ))}
    </Box>
  )}

 
</Grid>


  {/* Form */}
  <Grid container direction="column" spacing={2} sx={{ ml: isDesktop ? 4 : 0, width: "100%" }}>
    <Grid item xs={12}>
       <Typography fontWeight="500" sx={{ mb: 1 }}>
              Category
            </Typography>
            <TextField
              fullWidth
              value={product.categoryName}
              onChange={(e) => setCategory(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  backgroundColor: "#fff",
                 
                  fontSize: isDesktop ? 18 : 16
                },
                "& .MuiInputBase-input::placeholder": {
                  color: "#A0A0A0",
                
                  fontSize: isDesktop ? 14 : 18
                },
              }}
            />
    </Grid>

    <Grid item xs={12}>
      <Typography fontWeight="500" sx={{ mb: 1 }}>
        Product Title
      </Typography>
      <TextField
        fullWidth
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            backgroundColor: "#fff",
           
            fontSize: isDesktop ? 18 : 16
          },
          "& .MuiInputBase-input::placeholder": {
            color: "#A0A0A0",
          
            fontSize: isDesktop ? 14 : 18
          },
        }}
      />
    </Grid>

    <Grid item xs={12}>
      <Typography fontWeight="500" sx={{ mb: 1 }}>
        Description
      </Typography>
      <TextField
        fullWidth
        multiline
        rows={3}
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            backgroundColor: "#fff",
           
            fontSize: isDesktop ? 18 : 16
          },
          "& .MuiInputBase-input::placeholder": {
            color: "#A0A0A0",
          
            fontSize: isDesktop ? 14 : 18
          },
        }}
      />
    </Grid>
  </Grid>
</Box>




      {/* Form Fields */}
      <Grid container spacing={2} sx={{ mt: 4, flexDirection: isDesktop ? "row" : "column" }}>
  <Grid item xs={12} sm={6}>
    <Typography font="800" sx={{ mb: 1 }}>
      Price
    </Typography>
    <TextField
      fullWidth
      value={price}
      onChange={(e) => setPrice(e.target.value.replace(/[^0-9.]/g, ''))}
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: "12px",
          backgroundColor: "#fff",
         
          fontSize: isDesktop ? 18 : 16
        },
        "& .MuiInputBase-input::placeholder": {
          color: "#A0A0A0",
        
          fontSize: isDesktop ? 14 : 18
        },
      }}
    />
  </Grid>
  <Grid item xs={12} sm={6}>
  <Typography fontWeight="500" sx={{ mb: 1 }}>
    Availability Duration
  </Typography>
  <TextField
    fullWidth
    value={availability}
    onChange={(e) => setAvailability(e.target.value)}
    sx={{
      "& .MuiOutlinedInput-root": {
        borderRadius: "12px",
        backgroundColor: "#fff",
       
        fontSize: isDesktop ? 18 : 16
      },
      "& .MuiInputBase-input::placeholder": {
        color: "#A0A0A0",
      
        fontSize: isDesktop ? 14 : 18
      },
    }}
  />
</Grid>

  <Grid item xs={12} sm={6}>
    <Typography fontWeight="500" sx={{ mb: 1 }}>
      Location
    </Typography>
    <TextField
      fullWidth
      value={location}
      onChange={(e) => setLocation(e.target.value)}
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: "12px",
          backgroundColor: "#fff",
         
          fontSize: isDesktop ? 18 : 16
        },
        "& .MuiInputBase-input::placeholder": {
          color: "#A0A0A0",
        
          fontSize: isDesktop ? 14 : 18
        },
      }}
    />
  </Grid>



  <Grid item xs={12} sm={6}>
  <Typography fontWeight="500" sx={{ mb: 1 }}>
    Promotion Duration
  </Typography>
  <TextField
    fullWidth
    value={promotionDuration}
    onChange={(e) => setPromotionDuration(e.target.value)}
    sx={{
      "& .MuiOutlinedInput-root": {
        borderRadius: "12px",
        backgroundColor: "#fff",
       
        fontSize: isDesktop ? 18 : 16
      },
      "& .MuiInputBase-input::placeholder": {
        color: "#A0A0A0",
      
        fontSize: isDesktop ? 14 : 18
      },
    }}
  />
</Grid>
</Grid>

   

      {/* Buttons */}
      <Box
  sx={{
    display: "flex",
    flexDirection: { xs: "column", md: "row" }, 
    justifyContent: "center",
    gap: 2, 
    mt: 4,
  }}
>
  <Button
    sx={{
      borderRadius: "9999px",
      width: { xs: "100%", md: "40%" }, // responsive width
      padding: "10px 20px",
      fontWeight: "bold",
      textTransform: "none",
      fontSize: "14px",
      backgroundColor: "#EEE6FE !important",
      color: "#5604F6 !important",
    }}
    onClick={handleReset}
  >
    Reset to Default
  </Button>

  <Button
    variant="contained"
    sx={{
      borderRadius: "9999px",
      width: { xs: "100%", md: "40%" }, // responsive width
      padding: "10px 20px",
      backgroundColor: "#5604F6 !important",
      color: "#EEE6FE !important",
      textTransform: "none",
      fontSize: "14px",
      fontWeight: "bold",
    }}
    onClick={handleSaveUpdates}
    disabled={loading}
  >
    {loading ? (
      <CircularProgress size={24} sx={{ color: "white" }} />
    ) : (
      "Save Updates"
    )}
  </Button>
</Box>


      {/* Success Modal */}
      <Dialog
        open={successModalOpen}
        onClose={() => setSuccessModalOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Success!</DialogTitle>
        <DialogContent>
          <Typography variant="body1" color="textSecondary">
            Product updated successfully!
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSuccessModalOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Error Modal */}
      <Dialog
        open={errorModalOpen}
        onClose={() => setErrorModalOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Error!</DialogTitle>
        <DialogContent>
          <Typography variant="body1" color="textSecondary">
            Something went wrong. Please try again.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setErrorModalOpen(false)} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
    </Box>
  );
};

export default EditProductPage;
